import React from "react";
import "../../styles/testimonials.css"; // ensure this path matches your project
import { Helmet } from "react-helmet-async";

export default function TestimonialsPage() {
  return (
    <>
    <Helmet>
  <title>Drone Education Testimonials – Principals, Teachers & Students | PracVerse</title>
  <link rel="icon" href="/favicon.ico" />
<link rel="shortcut icon" href="/favicon.ico" />
<link rel="apple-touch-icon" href="/favicon.ico" />

  <meta
    name="description"
    content="Watch and read testimonials from school principals, teachers, students and partners who have experienced PracVerse drone education programs."
  />
  <link rel="canonical" href="https://www.pracverse.com/testimonials" />

  <meta property="og:title" content="Drone Education Testimonials – PracVerse" />
  <meta
    property="og:description"
    content="Real voices from schools, colleges and NGOs about the impact of PracVerse drone education initiatives."
  />
  <meta property="og:url" content="https://www.pracverse.com/testimonials" />
  <meta property="og:image" content="https://www.pracverse.com/images/og-testimonials.jpg" />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "PracVerse Testimonials",
      "url": "https://www.pracverse.com/testimonials"
      // If you have a testimonials array, you can map it into Review items here.
    })}
  </script>
</Helmet>



    <div className="testimonials-page">

      {/* HERO */}
      <section className="testimonials-hero">
        <div className="container">
          <h1 className="testimonials-title">What People Say</h1>
          <p className="testimonials-sub">
            Hear from school principals, students, and parents about their experiences with our Drone Education Programs
          </p>
        </div>
      </section>

      <div className="container">

        {/* PRINCIPALS: 2 video cards */}
       
        <section className="test-section">
           <div className="test-section-heading">
  <h2>School Principals</h2>
  <div className="heading-underline"></div>
</div>
          <div className="home-test-grid">
            <article className="home-test-card">
              <div className="home-video-area">
                <div className="home-video-placeholder">
                  <video
                    controls
                    playsInline
                    preload="metadata"
                    poster="/review_videos/mvj_pt_cover.png"
                    // poster="/videos/principal-1-poster.jpg"
                  >
                    {/* <source src="/videos/principal-1.mp4" type="video/mp4" /> */}
                    <source src="/review_videos/MVJ_Bangalore.mp4" type="video/mp4" />

                    {/* <source src="/videos/principal-1.webm" type="video/webm" /> */}
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>

              <div className="home-test-meta">
                <div className="meta-left">
                  <img className="avatar" src="/logos/MVJ_logo.png" alt="MVJ" />
                  <div>
                    <div className="meta-name">Mrs. Vamsheepriya Amar</div>
                    <div className="meta-role">MVJ International School, Bangalore</div>
                  </div>
                </div>

                <div className="meta-quote">“A Grade 2 child confidently used scientific terms like lift and drag — concepts usually taught in higher classes — just through the drone sessions...”</div>
              </div>
            </article>



            <article className="home-test-card">
              <div className="home-video-area">

                <div className="home-video-placeholder">
                  <video
                    controls
                    playsInline
                    preload="metadata"
                    poster="/review_videos/pt_dav.png"
                    // poster="/videos/principal-1-poster.jpg"
                  >
                    <source src="/logos/review_dav.mp4" type="video/mp4" />
                    {/* <source src="/videos/principal-1.webm" type="video/webm" /> */}
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>

              <div className="home-test-meta">
                <div className="meta-left">
                  <img className="avatar" src="/logos/DAV_logo.png" alt="DAV" />
                  <div>
                    <div className="meta-name">Mrs. Priyanka Tyagi</div>
                    <div className="meta-role">DAV Public School, Delhi</div>
                  </div>
                </div>

                <div className="meta-quote">"Students were fascinated by drones and truly enjoyed understanding the coding and real-world applications behind them...”</div>
              </div>
            </article>


          </div>
        </section>

        {/* STUDENTS: 4 video cards */}
        <section className="test-section">
          <div className="test-section-heading">
  <h2>Students</h2>
  <div className="heading-underline"></div>
</div>

          {/* use a 2x2 grid for students */}
          <div className="home-test-grid students-grid">
            <article className="home-test-card">
  <div className="home-video-area">
    <div className="home-video-placeholder">
      <video
        controls
        playsInline
        preload="metadata"
        poster="/review_videos/bps_ana_pt.png"
        // poster="/videos/principal-1-poster.jpg"
      >
        {/* <source src="/videos/principal-1.mp4" type="video/mp4" /> */}
        <source src="/review_videos/BPS_Akshra_and_Ananya.mp4" type="video/mp4" />

        {/* <source src="/videos/principal-1.webm" type="video/webm" /> */}
        Your browser does not support the video tag.
      </video>
    </div>
  </div>

  <div className="home-test-meta">
    <div className="meta-left">
      <img className="avatar" src="/logos/logo_bps.jpeg" alt="BPS" />
      <div>
        <div className="meta-name">Akshra and Ananya</div>
        <div className="meta-role">Bharti Public School, Delhi</div>
      </div>
    </div>

    <div className="meta-quote">“The drone workshop was an immersive experience — the physical flying, the crashes, and the memories made it unforgettable...”</div>
  </div>
</article>



<article className="home-test-card">
  <div className="home-video-area">
    <div className="home-video-placeholder">
      <video
        controls
        playsInline
        preload="metadata"
        poster="/review_videos/pt_trishika.png"
        // poster="/videos/principal-1-poster.jpg"
      >
        {/* <source src="/videos/principal-1.mp4" type="video/mp4" /> */}
        <source src="/review_videos/TBS_Trishika.mp4" type="video/mp4" />

        {/* <source src="/videos/principal-1.webm" type="video/webm" /> */}
        Your browser does not support the video tag.
      </video>
    </div>
  </div>

  <div className="home-test-meta">
    <div className="meta-left">
      <img className="avatar" src="/logos/logo_tbs.jpg" alt="TBS" />
      <div>
        <div className="meta-name">Trishika</div>
        <div className="meta-role">The Beacon School, Gurugoan</div>
      </div>
    </div>

    <div className="meta-quote">“The best part was making the drone fly a perfect square using block programming — no controller needed...”</div>
  </div>
</article>



<article className="home-test-card">
  <div className="home-video-area">
    <div className="home-video-placeholder">
      <video
        controls
        playsInline
        preload="metadata"
        poster="/review_videos/pt_shashwat.png"
        // poster="/videos/principal-1-poster.jpg"
      >
        {/* <source src="/videos/principal-1.mp4" type="video/mp4" /> */}
        <source src="/review_videos/NGF_Shashwat.mp4" type="video/mp4" />

        {/* <source src="/videos/principal-1.webm" type="video/webm" /> */}
        Your browser does not support the video tag.
      </video>
    </div>
  </div>

  <div className="home-test-meta">
    <div className="meta-left">
      <img className="avatar" src="/logos/NGF_Logo.png" alt="NGF" />
      <div>
        <div className="meta-name">Shashwat</div>
        <div className="meta-role">New Green Field School, Delhi</div>
      </div>
    </div>

    <div className="meta-quote">“I learned how drones work, how they’re made, and even about green, yellow, and red flying zones...”</div>
  </div>
</article>




<article className="home-test-card">
  <div className="home-video-area">

    <div className="home-video-placeholder">
      <video
        controls
        playsInline
        preload="metadata"
        poster="/review_videos/pt_parth.png"
        // poster="/videos/principal-1-poster.jpg"
      >
        {/* <source src="/videos/principal-1.mp4" type="video/mp4" /> */}
        <source src="/review_videos/ews_parth.mp4" type="video/mp4" />

        {/* <source src="/videos/principal-1.webm" type="video/webm" /> */}
        Your browser does not support the video tag.
      </video>
    </div>
  </div>

  <div className="home-test-meta">
    <div className="meta-left">
      <img className="avatar" src="/logos/logo_ews.jpeg" alt="EWS" />
      <div>
        <div className="meta-name">Parth</div>
        <div className="meta-role">Eva World School, Mumbai</div>
      </div>
    </div>

    <div className="meta-quote">“I loved assembling the drone, flying it, and the entire drone class experience...”</div>
  </div>
</article>


          </div>
        </section>

        


        {/* PARENTS: textual reviews (3 cards) */}
<section className="test-section">
  <div className="test-section-heading">
  <h2>Parents</h2>
  <div className="heading-underline"></div>
</div>

  <div className="parents-grid">

    {/* Parent 1 */}
    <article className="parent-card">

      <div className="parent-top">
        <img
          className="parent-avatar"
          src="/images/pic_krish.png"
          alt="Krish"
        />
        <div>
          <div className="parent-name">Poornima</div>
          <div className="parent-meta">Mother of Krish</div>
        </div>
      </div>

      <p className="parent-quote">
        “This was the first time my son actually built something from scratch. Seeing his drone take off was a proud moment for both of us. Thank you, PracVerse!”
      </p>
    </article>

    {/* Parent 2 */}
    <article className="parent-card">

      <div className="parent-top">
        <img
          className="parent-avatar"
          src="/images/Avika.jpg"
          alt="Avika"
        />
        <div>
          <div className="parent-name">Abha</div>
          <div className="parent-meta">Mother of Avika</div>
        </div>
      </div>

      <p className="parent-quote">
        “This wasn’t just a workshop; it was an experience! My daughter built a drone with her own hands and felt so accomplished. She’s now excited about tech!”
      </p>
    </article>

    {/* Parent 3 */}
    <article className="parent-card">

      <div className="parent-top">
        <img
          className="parent-avatar"
          src="/images/pic_parth.png"
          alt="Shaurya"
        />
        <div>
          <div className="parent-name">Prashant</div>
          <div className="parent-meta">Father of Shaurya</div>
        </div>
      </div>

      <p className="parent-quote">
        “As a parent, I want my child to learn skills that prepare them for the future. PracVerse does exactly that  making learning fun, practical, and inspiring.”
      </p>
    </article>

  </div>
</section>


      </div>
    </div>
    </>
  );
}




